/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreamStatusResponse
 */
export interface StreamStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StreamStatusResponse
     */
    isLive: boolean;
    /**
     * 
     * @type {string}
     * @memberof StreamStatusResponse
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof StreamStatusResponse
     */
    viewerCount: number;
    /**
     * 
     * @type {string}
     * @memberof StreamStatusResponse
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StreamStatusResponse
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof StreamStatusResponse
     */
    gameName?: string;
    /**
     * 
     * @type {number}
     * @memberof StreamStatusResponse
     */
    startedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof StreamStatusResponse
     */
    checkedAt: number;
}

/**
 * Check if a given object implements the StreamStatusResponse interface.
 */
export function instanceOfStreamStatusResponse(value: object): value is StreamStatusResponse {
    if (!('isLive' in value) || value['isLive'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('viewerCount' in value) || value['viewerCount'] === undefined) return false;
    if (!('checkedAt' in value) || value['checkedAt'] === undefined) return false;
    return true;
}

export function StreamStatusResponseFromJSON(json: any): StreamStatusResponse {
    return StreamStatusResponseFromJSONTyped(json, false);
}

export function StreamStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isLive': json['isLive'],
        'status': json['status'],
        'viewerCount': json['viewerCount'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'title': json['title'] == null ? undefined : json['title'],
        'gameName': json['gameName'] == null ? undefined : json['gameName'],
        'startedAt': json['startedAt'] == null ? undefined : json['startedAt'],
        'checkedAt': json['checkedAt'],
    };
}

export function StreamStatusResponseToJSON(json: any): StreamStatusResponse {
    return StreamStatusResponseToJSONTyped(json, false);
}

export function StreamStatusResponseToJSONTyped(value?: StreamStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isLive': value['isLive'],
        'status': value['status'],
        'viewerCount': value['viewerCount'],
        'thumbnailUrl': value['thumbnailUrl'],
        'title': value['title'],
        'gameName': value['gameName'],
        'startedAt': value['startedAt'],
        'checkedAt': value['checkedAt'],
    };
}

